class VariantSwatches extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('change', this.onVariantChange);
  }
  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateCheckout();
    this.updateURL();

    if (!this.currentVariant) {
    } else {
      this.updateMedia();
      this.updatePrice();
      this.updateServiceInfo();
    }
  }

  updateOptions() {
    const variantSelectors = Array.from(this.querySelectorAll('.cstm-variant-selector'));
    this.options = variantSelectors.map((variantSelector) => {
      return Array.from(variantSelector.querySelectorAll('.cstm-variant-input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}&variant=${this.currentVariant.id}`);
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.cstm-variant-selector')];
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;      
      const optionInputs = [...option.querySelectorAll('input[type="radio"]')]      
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      
      const availableOptionInputsValues = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);

      optionInputs.forEach( (optionInput, optionInputIndex) => {
        const optionAvailable = availableOptionInputsValues.includes(optionInput.value);

        if (optionAvailable) {
          if (optionInput.disabled) optionInput.disabled = false;
        } else {
          if (!optionInput.disabled) optionInput.disabled = true;
        }
      });
    });
  }

  updateCheckout() {
    const checkoutButton = document.getElementById(`Checkout-${this.dataset.section}`);
    checkoutButton.dataset.id = this.currentVariant.id;

    if (this.currentVariant.available) {
      checkoutButton.classList.remove('disabled');
    } else {
      checkoutButton.classList.add('disabled');
    }
  }

  updateMedia() {
    const currentVariantTitle = this.currentVariant.title;
    const selectedVariantSelector = document.querySelector(`.product-media-image[data-variant="${currentVariantTitle}"]`);

    if (selectedVariantSelector && !selectedVariantSelector.classList.contains('is-active')) {
      document.querySelector('.product-media-image.is-active').classList.remove('is-active')
      selectedVariantSelector.classList.add('is-active')
    }
  }

  updatePrice() {
    const currentVariantId = this.currentVariant.id;
    const currentVariantPriceSelector = document.getElementById(`ProductPrice-${this.dataset.section}`);
    const currentVariantPrice = productVariantsData[currentVariantId].originalPrice;

    if (currentVariantPriceSelector && currentVariantPrice) {
      currentVariantPriceSelector.innerHTML = currentVariantPrice;
  
      const currentVariantComparePriceSelector = document.getElementById(`ProductComparePrice-${this.dataset.section}`);
      const currentVariantComparePrice = productVariantsData[currentVariantId].comparePrice;
      
      if (currentVariantComparePriceSelector && currentVariantComparePrice !== undefined) {
        if (currentVariantComparePriceSelector.classList.contains('visually-hidden')) currentVariantComparePriceSelector.classList.remove('visually-hidden');
        currentVariantComparePriceSelector.innerHTML = currentVariantComparePrice;
      } else {
        currentVariantComparePriceSelector.classList.add('visually-hidden');
        currentVariantComparePriceSelector.innerHTML = '';
      }
    }
  }

  updateServiceInfo() {
    const currentVariantId = this.currentVariant.id;
    const serviceSelectors = ['deliverdIn', 'freeReturn', 'warrantyDuration'];

    serviceSelectors.map( (serviceSelector, serviceSelectorIndex) => {
      const serviceElements = document.getElementById(`Product-${this.dataset.section}`).querySelectorAll(`.${serviceSelectors[serviceSelectorIndex]}`);
      const serviceElementValue = productVariantsData[currentVariantId][serviceSelectors[serviceSelectorIndex]];
      
      serviceElements.forEach( serviceElement => {
        const serviceElementParent = serviceElement.closest('.service-txt-parent');

        if (serviceElementValue !== undefined && serviceElementValue !== '') {
          if (serviceElementParent.classList.contains('hide')) serviceElementParent.classList.remove('hide')
          serviceElement.innerHTML = serviceElementValue;
        } else {
          serviceElementParent.classList.add('hide');
          serviceElement.innerHTML = '';
        }
      });
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-swatches', VariantSwatches);

document.querySelectorAll('.CheckoutButton').forEach( element => {
  element.addEventListener('click', () => {
    const id = element.dataset.id;
    const url = `${window.location.origin}/cart/${id}:1`;

    if (!element.classList.contains('disabled')) {
      window.location.href = url;
    }
  })
});
